import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "key-stroke-hints" }
const _hoisted_2 = { class: "matrix" }
const _hoisted_3 = { class: "key-stroke" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _cache[0] || (_cache[0] = _createElementVNode("td", null, null, -1 /* CACHED */)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.remaining_keystrokes, (rk) => {
            return (_openBlock(), _createElementBlock("td", { key: rk }, _toDisplayString(rk
                .split("")
                .map((c) => $setup.decodeKeyStroke(c))
                .join("")), 1 /* TEXT */))
          }), 128 /* KEYED_FRAGMENT */))
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.first_keystroke, (fk) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: fk,
            class: _normalizeClass({ 'highlight-row': $setup.suffix[0] === fk })
          }, [
            _createElementVNode("td", null, [
              _createElementVNode("span", _hoisted_3, _toDisplayString($setup.prefix
                .split("")
                .map((c) => $setup.decodeKeyStroke(c))
                .join("")), 1 /* TEXT */),
              _createTextVNode(_toDisplayString($setup.decodeKeyStroke(fk)), 1 /* TEXT */)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.remaining_keystrokes, (rk) => {
              return (_openBlock(), _createElementBlock("td", {
                key: rk,
                class: _normalizeClass({
              'highlight-row': $setup.suffix.length > 1 && $setup.suffix.slice(1) === rk,
            })
              }, _toDisplayString(`_${$setup.prefix}${fk}${rk}` in $setup.utf8data
                ? String.fromCodePoint($setup.utf8data[`_${$setup.prefix}${fk}${rk}`])
                : " "), 3 /* TEXT, CLASS */))
            }), 128 /* KEYED_FRAGMENT */))
          ], 2 /* CLASS */))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ])
  ]))
}